// src/mutations/saveLibraryCardMutation.js
import { gql } from "@apollo/client";

export const SAVE_LIBRARY_CARD_MUTATION = gql`
  mutation SaveLibraryCard($input: SaveLibraryCardInput!) {
    saveLibraryCard(input: $input) {
      success
      message
      record
    }
  }
`;
